import classnames from 'classnames';
import React, { useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import '../../../themes/alert.js';
import '../../../themes/button.js';
import '../../../themes/checkbox.js';
import '../../../themes/divider.js';
import '../../../themes/dropdown.js';
import '../../../themes/fieldset.js';
import '../../../themes/input.js';
import '../../../themes/list.js';
import '../../../themes/listbox.js';
import '../../../themes/loader.js';
import '../../../themes/option.js';
import '../../../themes/popout.js';
import '../../../themes/switch.js';
import { lightTheme } from '../../../themes/themes.js';
import '../../../themes/tooltip.js';

const BaseTextfieldInner = (props)=>{
    const { children, ...otherProps } = props;
    return /*#__PURE__*/ React.createElement("div", {
        ...otherProps,
        className: classnames({
            'bf-textfield__inner': true,
            [`${otherProps?.className}`]: !!otherProps?.className
        })
    }, children);
};
const Inner = styled(BaseTextfieldInner)`
  position: relative;
  flex: 1;
`;
const TextfieldInner = (props)=>{
    const themeContext = useContext(ThemeContext);
    return /*#__PURE__*/ React.createElement(ThemeProvider, {
        theme: themeContext || lightTheme
    }, /*#__PURE__*/ React.createElement(Inner, props));
};

export { BaseTextfieldInner, TextfieldInner };
//# sourceMappingURL=textfield-inner.js.map
